module.exports = __webpack_public_path__ + "d1aece6d84fdce4292f561e260215408.png";